import React, {useRef, useState} from 'react';

import dayjs from "dayjs";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowForward from '@mui/icons-material/ArrowForward';

import ExperienceForm from './components/ExperienceForm';
import {SectionProps} from '../../types/form';


const Section5 = (props: SectionProps) => {

    const {handleNext, values, setValues} = props;

    /**
     * FORM SUBMIT TO NEXT SECTION
     */
    const formRef = useRef<HTMLFormElement>(null);
    const [errors, setErrors] = useState<Record<number, Record<string, string>>>({});
    const handleNextClick = () => {
        if (!formRef.current) {
            return;
        }

        formRef.current.reportValidity();

        let error = false;

        values.experiences.forEach((experience, index) => {
            // Validate date formats
            if (!experience.start_date || isNaN((new Date(experience.start_date?.toString())).valueOf())) {
                setErrors({...errors, [index]: {start_date: 'Data inválida'}});
                error = true;
                return;
            }

            if (experience.end_date && isNaN((new Date(experience.end_date?.toString())).valueOf())) {
                setErrors({...errors, [index]: {end_date: 'Data inválida'}});
                error = true;
                return;
            }

            // Validate dates logic
            if (experience.start_date > dayjs()) {
                setErrors({
                    ...errors,
                    [index]: {start_date: 'Data de início não pode ser maior que hoje'}
                });
                error = true;
                return;
            }

            if (experience.end_date && experience.start_date > experience.end_date) {
                setErrors({
                    ...errors,
                    [index]: {end_date: 'Data de saída não pode ser menor que data de início'}
                });
                error = true;
                return;
            }
        });

        if (error) {
            return;
        }

        if (formRef.current.checkValidity()) {
            handleNext();
        }
    };

    const handleAddExperience = () => {
        setValues({
            ...values,
            experiences: [...values.experiences, {
                company: '',
                vehicle_types: [],
                start_date: null,
                end_date: null,
                resignation_reason: '',
                other_vehicle_types: '',
            }],
        });
    };

    return (
        <Box>
            <Typography variant={'h2'}>
                Experiência
            </Typography>
            <Typography variant={'body1'} sx={{mb: '20px'}}>
                Atenção! As experiências inseridas devem ser comprovadas em
                carteira de trabalho, ou através de
                manifestos de carga, carta frete ou MIC; assim como você é
                totalmente responsável pela veracidade das
                informações informadas abaixo:
            </Typography>

            <Box component={'form'} ref={formRef}>

                <ExperienceForm
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    index={0}
                />

                {values.experiences.slice(1).map((experience, index) => (
                    <ExperienceForm
                        key={index}
                        values={values}
                        setValues={setValues}
                        errors={errors}
                        index={index + 1}
                    />
                ))}

                <Button
                    variant={'contained'}
                    onClick={handleAddExperience}
                    color={'secondary'}
                    size={'small'}
                    sx={{
                        mt: 3,
                    }}
                >
                    Adicionar Experiência
                </Button>

                <Stack direction={'row'} justifyContent={'end'} sx={{mt: 5}}>
                    <Button variant={'contained'} onClick={handleNextClick}>
                        Próximo
                        <ArrowForward fontSize={'small'} sx={{ml: 2}}/>
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
};

export default Section5;